const equalAndSameOrder = (array1, array2) => {
  var is_same =
    array1.length == array2.length &&
    array1.every(function (element, index) {
      return element === array2[index]
    })

  return is_same
}

export default equalAndSameOrder
